import { UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query'

import { GasEstimationResponse, apiGetGasEstimates } from '@src/api/gas_estimation.api'
import { createContextLogger } from '@src/utils/logger'

const logger = createContextLogger('useFetchServerlessGasEstimates')

/**
 * React Query hook for fetching gas fee estimates from the Gas Estimation Worker
 */
export function useFetchServerlessGasEstimates(
    options?: UseQueryOptions<GasEstimationResponse, Error, GasEstimationResponse>
): UseQueryResult<GasEstimationResponse, Error> {
    return useQuery<GasEstimationResponse, Error>({
        queryKey: ['gasEstimates'],
        queryFn: apiGetGasEstimates,
        staleTime: 10 * 1000,
        refetchInterval: 10 * 1000,
        ...options,
    })
}
